(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hidock-where-to-buy"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hidock-store-locator')) {
  customElements.define('hidock-store-locator', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {this.startPromotion(); return;}
      this.initialized = true;
      this.expanded = false;
      this.search = this.querySelector('[data-search]');
      this.region = this.querySelector('select[data-region]');
      this.brand = this.querySelector('select[data-brand]');
      this.cards = Array.from(this.querySelectorAll('[data-store]'));
      this.results = this.querySelector('.hwb__results');
      this.more = this.querySelector('[data-more]');
      this.count = this.querySelector('[data-count]');
      this.querySelector('.hwb__filters').hidden = false;
      this.search.addEventListener('input', () => {this.expanded = false; this.update();});
      [this.region, this.brand].forEach(el => el.addEventListener('change', () => {this.expanded = false; this.update();}));
      this.querySelectorAll('[data-reset]').forEach(el => el.addEventListener('click', () => {
        this.search.value = ''; this.region.value = ''; this.brand.value = ''; this.expanded = false; this.update(); this.search.focus();
      }));
      this.more.addEventListener('click', () => {this.expanded = !this.expanded; this.update();});
      this.update();
      this.startPromotion();
    }
    disconnectedCallback() {
      clearTimeout(this.promotionTimer);
      document.removeEventListener('visibilitychange', this.syncPromotion);
    }
    startPromotion() {
      this.promotion = this.querySelector('[data-promotion]');
      if (!this.promotion) return;
      document.removeEventListener('visibilitychange', this.syncPromotion);
      this.syncPromotion = () => this.updatePromotion();
      document.addEventListener('visibilitychange', this.syncPromotion);
      this.updatePromotion();
    }
    updatePromotion() {
      clearTimeout(this.promotionTimer);
      if (!this.isConnected || !this.promotion) return;
      const now = Date.now();
      const start = Number(this.promotion.dataset.start) * 1000;
      const main = Number(this.promotion.dataset.main) * 1000;
      const end = Number(this.promotion.dataset.end) * 1000;
      this.promotion.hidden = now < start || now >= end;
      this.promotion.textContent = now < main ? this.promotion.dataset.advanceLabel : this.promotion.dataset.mainLabel;
      const next = [start, main, end].find(time => time > now);
      if (next) this.promotionTimer = setTimeout(() => this.updatePromotion(), Math.min(next - now + 50, 2147483647));
    }
    normalize(value) {return value.normalize('NFKC').toLowerCase().replace(/\s+/g, ' ').trim();}
    update() {
      const terms = this.normalize(this.search.value).split(' ').filter(Boolean);
      const active = terms.length || this.region.value || this.brand.value;
      const matches = this.cards.filter(card => terms.every(term => this.normalize(card.textContent).includes(term)) && (!this.region.value || card.dataset.region === this.region.value) && (!this.brand.value || card.dataset.brand === this.brand.value));
      const featuredMode = !this.expanded && !active;
      const ordered = featuredMode ? this.cards.slice().sort((a,b)=>(Number(a.dataset.featuredOrder)||999)-(Number(b.dataset.featuredOrder)||999)) : this.cards;
      ordered.forEach(card=>this.results.appendChild(card));
      const displayed = featuredMode ? ordered.filter(card=>Number(card.dataset.featuredOrder)>0).slice(0,Number(this.dataset.initialCount)) : matches;
      this.cards.forEach(card => {card.hidden = true;});
      displayed.forEach(card => {card.hidden = false;});
      this.count.textContent = matches.length;
      this.more.hidden = Boolean(active) || matches.length <= Number(this.dataset.initialCount);
      this.more.setAttribute('aria-expanded', String(this.expanded));
      this.querySelector('[data-more-label]').hidden = this.expanded;
      this.querySelector('[data-less-label]').hidden = !this.expanded;
      this.querySelector('[data-more-arrow]').textContent = this.expanded ? '↑' : '↓';
      this.querySelector('[data-featured-label]').hidden = !featuredMode;
      this.querySelector('[data-all-label]').hidden = Boolean(active) || featuredMode;
      this.querySelector('[data-empty]').hidden = matches.length > 0;
      this.querySelector('.hwb__reset').hidden = !active || matches.length === 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hidock-wtb-photo-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hidock-store-locator')) {
  customElements.define('hidock-store-locator', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {this.startPromotion(); return;}
      this.initialized = true;
      this.expanded = false;
      this.search = this.querySelector('[data-search]');
      this.region = this.querySelector('select[data-region]');
      this.brand = this.querySelector('select[data-brand]');
      this.cards = Array.from(this.querySelectorAll('[data-store]'));
      this.results = this.querySelector('.hwb__results');
      this.more = this.querySelector('[data-more]');
      this.count = this.querySelector('[data-count]');
      this.querySelector('.hwb__filters').hidden = false;
      this.search.addEventListener('input', () => {this.expanded = false; this.update();});
      [this.region, this.brand].forEach(el => el.addEventListener('change', () => {this.expanded = false; this.update();}));
      this.querySelectorAll('[data-reset]').forEach(el => el.addEventListener('click', () => {
        this.search.value = ''; this.region.value = ''; this.brand.value = ''; this.expanded = false; this.update(); this.search.focus();
      }));
      this.more.addEventListener('click', () => {this.expanded = !this.expanded; this.update();});
      this.update();
      this.startPromotion();
    }
    disconnectedCallback() {
      clearTimeout(this.promotionTimer);
      document.removeEventListener('visibilitychange', this.syncPromotion);
    }
    startPromotion() {
      this.promotion = this.querySelector('[data-promotion]');
      if (!this.promotion) return;
      document.removeEventListener('visibilitychange', this.syncPromotion);
      this.syncPromotion = () => this.updatePromotion();
      document.addEventListener('visibilitychange', this.syncPromotion);
      this.updatePromotion();
    }
    updatePromotion() {
      clearTimeout(this.promotionTimer);
      if (!this.isConnected || !this.promotion) return;
      const now = Date.now();
      const start = Number(this.promotion.dataset.start) * 1000;
      const main = Number(this.promotion.dataset.main) * 1000;
      const end = Number(this.promotion.dataset.end) * 1000;
      this.promotion.hidden = now < start || now >= end;
      this.promotion.textContent = now < main ? this.promotion.dataset.advanceLabel : this.promotion.dataset.mainLabel;
      const next = [start, main, end].find(time => time > now);
      if (next) this.promotionTimer = setTimeout(() => this.updatePromotion(), Math.min(next - now + 50, 2147483647));
    }
    normalize(value) {return value.normalize('NFKC').toLowerCase().replace(/\s+/g, ' ').trim();}
    update() {
      const terms = this.normalize(this.search.value).split(' ').filter(Boolean);
      const active = terms.length || this.region.value || this.brand.value;
      const matches = this.cards.filter(card => terms.every(term => this.normalize(card.textContent).includes(term)) && (!this.region.value || card.dataset.region === this.region.value) && (!this.brand.value || card.dataset.brand === this.brand.value));
      const featuredMode = !this.expanded && !active;
      const ordered = featuredMode ? this.cards.slice().sort((a,b)=>(Number(a.dataset.featuredOrder)||999)-(Number(b.dataset.featuredOrder)||999)) : this.cards;
      ordered.forEach(card=>this.results.appendChild(card));
      const displayed = featuredMode ? ordered.filter(card=>Number(card.dataset.featuredOrder)>0).slice(0,Number(this.dataset.initialCount)) : matches;
      this.cards.forEach(card => {card.hidden = true;});
      displayed.forEach(card => {card.hidden = false;});
      this.count.textContent = matches.length;
      this.more.hidden = Boolean(active) || matches.length <= Number(this.dataset.initialCount);
      this.more.setAttribute('aria-expanded', String(this.expanded));
      this.querySelector('[data-more-label]').hidden = this.expanded;
      this.querySelector('[data-less-label]').hidden = !this.expanded;
      this.querySelector('[data-more-arrow]').textContent = this.expanded ? '↑' : '↓';
      this.querySelector('[data-featured-label]').hidden = !featuredMode;
      this.querySelector('[data-all-label]').hidden = Boolean(active) || featuredMode;
      this.querySelector('[data-empty]').hidden = matches.length > 0;
      this.querySelector('.hwb__reset').hidden = !active || matches.length === 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
